<template>
  <div class="container page">
    <!-- 固定顶部导航栏 -->
    <div class="fixed-nav">
      <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="main-content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" description="" />
        <div v-for="(v,key) in list" :key="key" class="record-card">
          <!-- 顶部状态和金额 -->
          <div class="card-top">
            <div class="status-badge" :class="getStatusClass(v)">
              {{ getStatusText(v) }}
            </div>
            <div class="amount" :class="v.win > 0 ? 'win' : 'lose'">
              {{ v.win > 0 ? '+' : '' }}{{ v.win }}
            </div>
          </div>

          <!-- 标题和期号 -->
          <div class="card-title">
            <div class="lottery-name">
              <img :src="v.lottery.ico" style="width: 20px;height: 20px;border-radius: 50%;vertical-align: middle;margin-right: 6px;">
              <span style="vertical-align: middle;">{{ getLotteryName(v.lottery) }}</span>
            </div>
            <div class="expect">{{ v.expect }}</div>
          </div>

          <!-- 投注内容 -->
          <div class="card-detail">
            <div class="detail-row">
              <span class="detail-label">{{$t('auth.top2')}}:</span>
              <div class="detail-value">
                <span v-for="(vs,keys) in v.wan" :key="keys" class="tag">{{ getTagName(vs.name) }}</span>
              </div>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{$t('auth.top3')}}:</span>
              <div class="detail-value">
                <span v-for="(vs,keys) in v.jie" :key="keys" class="tag blue">{{ getTagName(vs.name) }}</span>
              </div>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{$t('auth.top1')}}:</span>
              <div class="detail-value">{{ v.money }}</div>
            </div>
          </div>

          <!-- 时间信息 -->
          <div class="card-time">
            <div class="time-row">
              <span>{{$t('reservation.order_time')}}: {{ v.create_time }}</span>
            </div>
            <div class="time-row">
              <span>{{$t('reservation.settle_time')}}: {{ v.update_time }}</span>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      rose: '',
      lily: '',
      fireworks: '',
      balloon: '',
      lang: this.$t("auth.lang")
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getUserGameList();
      }, 500);
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryName(lottery) {
      if (!lottery) return '';
      if (this.lang == 'zh') return lottery.name;
      if (this.lang == 'ja') return lottery.name_ja;
      if (this.lang == 'en') return lottery.name_es;
      if (this.lang == 'kr') return lottery.name_kr;
      return lottery.name;
    },
    getStatusText(v) {
      if (v.win > 0) return  this.$t("auth.top38");
      if (v.status == 1) return  this.$t("auth.top39");
      return  this.$t("auth.top40");
    },
    getStatusClass(v) {
      if (v.win > 0) return 'success';
      if (v.status == 1) return 'fail';
      return 'pending';
    },
    getTagName(name) {
      if (name == 'big') return this.rose;
      if (name == 'small') return this.lily;
      if (name == 'one') return this.fireworks;
      return this.balloon;
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      this.getUserGameList();
    }
    const lang = this.$t("auth.lang");
    if (lang == 'zh') {
      this.rose = '新歌榜';
      this.lily = '飙升榜';
      this.balloon = '热歌榜';
      this.fireworks = '日更榜';
    } else if (lang == 'en') {
      // 缩短英文标签，防止换行
      this.rose = 'Rising';
      this.lily = 'Trending';
      this.balloon = 'Hot';
      this.fireworks = 'Daily';
    } else if (lang == 'ja') {
      this.rose = '新曲';
      this.lily = '急上昇';
      this.balloon = 'ヒット';
      this.fireworks = '日次';
    } else {
      this.rose = '신곡';
      this.lily = '급상승';
      this.balloon = '인기';
      this.fireworks = '일일';
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100%;
  position: relative;
  overflow: auto;
  background: #f7f8fa;
}

/* 固定顶部导航栏 */
.fixed-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: #8600ff;
}

/* 顶部导航栏 */
.nav-bar {
  background: #8600ff !important;
  :deep(.van-nav-bar__title) {
    color: #fff;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #fff;
  }
}

/* 主内容区域 */
.main-content {
  margin-top: 50PX;
  margin-bottom: 60PX;
  padding: 15PX;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #333;
  font-size: 14PX;
}

::v-deep .van-loading__text {
  color: #333;
  font-size: 14PX;
}

/* 记录卡片 */
.record-card {
  background: #fff;
  border-radius: 12PX;
  padding: 15PX;
  margin-bottom: 15PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
}

/* 顶部状态和金额 */
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12PX;
}

.status-badge {
  font-size: 12PX;
  font-weight: 600;
  padding: 4PX 12PX;
  border-radius: 20PX;
  white-space: nowrap;
}

.status-badge.success {
  color: #07c160;
  background: rgba(7, 193, 96, 0.1);
}

.status-badge.fail {
  color: #f53d87;
  background: rgba(245, 61, 135, 0.1);
}

.status-badge.pending {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.1);
}

.amount {
  font-size: 20PX;
  font-weight: 700;
  white-space: nowrap;
}

.amount.win {
  color: #07c160;
}

.amount.lose {
  color: #f53d87;
}

/* 标题和期号 */
.card-title {
  margin-bottom: 12PX;
}

.lottery-name {
  display: flex;
  align-items: center;
  font-size: 16PX;
  font-weight: 600;
  color: #333;
  margin-bottom: 4PX;
}

.lottery-name img {
  width: 20PX;
  height: 20PX;
  border-radius: 50%;
  margin-right: 6PX;
  flex-shrink: 0;
}

.expect {
  font-size: 13PX;
  color: #999;
}

/* 投注内容 - 优化为 flex 布局 */
.card-detail {
  background: #f9f9f9;
  border-radius: 8PX;
  padding: 10PX 12PX;
  margin-bottom: 12PX;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8PX;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  font-size: 13PX;
  font-weight: 600;
  color: #333;
  flex-shrink: 0; /* 不压缩 */
  margin-right: 8PX; /* 标签和内容间距 */
  white-space: nowrap; /* 防止标签换行 */
  line-height: 24PX;
}

.detail-value {
  font-size: 13PX;
  color: #666;
  display: flex;
  flex-wrap: wrap;
  gap: 4PX;
  align-items: flex-start;
  flex: 1;
  line-height: 24PX;
}

/* 标签样式优化 */
.tag {
  background: #dc3b40;
  color: #fff;
  border-radius: 4PX;
  padding: 2PX 8PX;
  font-size: 12PX;
  font-weight: 600;
  white-space: nowrap;
  display: inline-block;
}

.orange {
  background: linear-gradient(90deg, #ff7e5f, #ff5f6d);
  padding: 2PX 8PX;
  border-radius: 5PX;
  color: #fff;
  white-space: nowrap;
  font-size: 12PX;
}

.blue {
  background: #7c4dff;
  padding: 2PX 5PX;
  border-radius: 5PX;
  color: #fff;
  white-space: nowrap;
  font-size: 12PX;
}

/* 时间信息 */
.card-time {
  padding-top: 8PX;
  border-top: 1PX solid #f5f5f5;
}

.time-row {
  font-size: 13PX;
  color: #999;
  line-height: 20PX;
}

::v-deep .van-nav-bar__title {
  color: #fff !important;
  font-size: 18PX;
  font-weight: 600;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
}

::v-deep .van-nav-bar__text {
  color: #fff !important;
}
</style>